import * as React from 'react';

import classnames from 'classnames';

// @ts-expect-error - imported from .js/.jsx file
import {CloseIcon} from '../icon/svg/close-icon';

import styles from './message.module.css';

export type MessageType =
    | 'default'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | 'success-dark'
    | 'ai-info'
    | 'subtle';

type Props = {
    type: MessageType;
    children: React.ReactNode;
    /** Callback function for the close button */
    onClose?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    /** If true, the message will be rendered with a border and corner radius. */
    hasBorder?: boolean;
    /** If true, the content will be aligned to the left edge, instead of centered */
    leftAlignContent?: boolean;
    cta?: React.ReactNode;
    noRightPadding?: boolean;
    lessPadding?: boolean;
};

export class Message extends React.Component<Props> {
    static defaultProps = {
        type: 'default',
    };

    render() {
        const classes = classnames(styles[`container--${this.props.type}`], {
            [styles['container--bordered']]: this.props.hasBorder,
            [styles['container--left-aligned-content']]: this.props.leftAlignContent,
            [styles['has-cta']]: Boolean(this.props.cta),
        });

        const messageClasses = classnames(styles.message, {
            [styles['less-padding']]: this.props.lessPadding,
        });

        return (
            <div className={classes}>
                <div
                    style={this.props.noRightPadding ? {paddingRight: 0} : undefined}
                    className={messageClasses}
                >
                    {this.props.children}
                </div>
                {this.props.cta}
                {this.props.onClose ? (
                    <button
                        onClick={this.props.onClose}
                        // This is important because we dont want to
                        // submit forms if this component is nested in one.
                        type='button'
                        className={styles['button-close']}
                    >
                        <CloseIcon size={this.props.lessPadding ? 11 : 14} wrapWithDiv={false} />
                    </button>
                ) : undefined}
            </div>
        );
    }
}
